<template>
  <v-app>
    <v-main>
      <alert></alert>
      <slot />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Blank',
}
</script>

<style scoped></style>
